module.exports = __webpack_public_path__ + "img/icon19.3e03b134.png";